export const MSG_TYPE_ERROR = 'error';
export const MSG_TYPE_SUCCESS = 'success';
export const MSG_TYPE_INFO = 'info';
